var _sodipodiNamedview, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcehockey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 31.75 31.750002",
    id: "svg1696",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "icehockey.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1698",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    "inkscapeDocument-units": "px",
    showgrid: "false",
    inkscapeZoom: 4.3994184,
    inkscapeCx: 23.75314,
    inkscapeCy: 81.94265,
    "inkscapWindow-width": 2560,
    "inkscapeWindow-height": 1377,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "layer1",
    units: "px"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1693"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Ebene 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    style: {
      display: "inline"
    },
    transform: "translate(-0.03787441,-0.00135587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28.268593,25.266505 25.425197,25.14092 19.093641,13.941922 h -1.747314 l 6.962323,12.314552 c 0.12911,0.228243 0.366627,0.374019 0.628508,0.385653 l 3.264331,0.144064 c 0.01163,6.84e-4 0.02272,6.84e-4 0.03398,6.84e-4 0.404747,0 0.741192,-0.318583 0.7595,-0.726821 0.01844,-0.419531 -0.30664,-0.774728 -0.726376,-0.793549",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0342195
    },
    id: "path714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.505572,6.5399131 11.963164,4.7307309 15.458783,4.4152277 c 0.139274,-0.012661 0.269067,-0.053041 0.384969,-0.1146352 0.144338,-0.1440639 0.28563,-0.286759 0.423568,-0.4291119 0.08623,-0.1659643 0.128323,-0.357251 0.11029,-0.5574348 -0.0504,-0.5577769 -0.542824,-0.9687525 -1.101045,-0.9191343 L 9.828589,2.8869871 C 9.4509774,2.9212066 9.1240106,3.1631381 8.9808706,3.5138874 8.8376965,3.864979 8.9021317,4.2667152 9.148101,4.5551852 l 2.89435,3.3945691 c 0.477326,-0.4725706 0.969642,-0.9434301 1.463121,-1.4098412",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0342195
    },
    id: "path716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23.908282,8.6711002 c -0.302739,0.3045531 -0.670221,0.584126 -1.0942,0.8236621 -0.27468,0.1584359 -0.554458,0.3175556 -0.835023,0.4773616 l 0.234026,2.8826461 -0.654583,3.299781 c -0.10892,0.549222 0.247988,1.083046 0.797484,1.191863 0.06656,0.01335 0.133011,0.01951 0.198507,0.01951 0.473973,0 0.897576,-0.334323 0.993561,-0.816818 l 0.682267,-3.438028 c 0.01803,-0.09205 0.02351,-0.186154 0.01577,-0.279572 L 23.908282,8.6711002",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0342195
    },
    id: "path718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.015402,13.941922 H 9.7013611 l -1.9614929,5.942206 -4.87867,3.525288 c -0.605256,0.437324 -0.7414654,1.282544 -0.304232,1.887886 0.2645341,0.365807 0.6777065,0.560173 1.0972951,0.560173 0.2744229,0 0.5513883,-0.08316 0.7906575,-0.256304 l 5.2336864,-3.78159 C 9.9093469,21.652932 10.081642,21.417844 10.170783,21.14751 l 2.151274,-6.518462 2.883673,5.501802 -0.140094,6.033231 c -0.01725,0.746669 0.573997,1.365699 1.320528,1.38315 0.01084,0 0.02139,3.42e-4 0.0321,3.42e-4 0.732091,0 1.33401,-0.58481 1.35112,-1.320528 l 0.147964,-6.382954 c 0.0053,-0.22927 -0.04757,-0.455803 -0.154124,-0.659066 l -2.747821,-5.243103",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0342195
    },
    id: "path720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25.227066,6.0006146 C 23.919781,6.9002438 22.216713,6.694585 21.422856,5.5413896 20.628828,4.387852 21.04521,2.7234182 22.352256,1.823789 c 1.307422,-0.89962931 3.010627,-0.6939704 3.804382,0.4595671 0.793856,1.1535375 0.377748,2.8176293 -0.929572,3.7172585",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0342195
    },
    id: "path722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23.469316,7.5750514 c -1.193129,0 -2.243769,-0.5317702 -2.881791,-1.4587751 C 20.011303,5.2789264 19.879217,4.2561072 20.131996,3.2962518 19.370749,2.7809069 18.331608,3.1751149 17.392831,4.1599505 c -2.031505,2.181832 -4.963427,4.553924 -6.746568,6.8144605 -0.117647,0.147144 -0.159463,0.323374 -0.140095,0.502683 h 6.805803 c 1.577824,-0.938981 3.330237,-1.9015744 5.003636,-2.8655357 0.534029,-0.301131 0.939837,-0.6655682 1.196756,-1.0382179 -0.01431,3.422e-4 -0.02874,0.00171 -0.04305,0.00171",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0342195
    },
    id: "path726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20.291337,29.097817 h -5.604804 c -0.317214,0 -0.574543,-0.257673 -0.574543,-0.574887 0,-0.317215 0.257329,-0.574887 0.574543,-0.574887 h 5.604804 c 0.317556,0 0.574887,0.257672 0.574887,0.574887 0,0.317214 -0.257331,0.574887 -0.574887,0.574887",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0342195
    },
    id: "path776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.4580386,29.281359 0.24325553,24.690173 C 0.06130894,24.430326 0.12478351,24.071738 0.38463022,23.889793 0.64447692,23.707846 1.0031486,23.770843 1.1850953,24.03069 l 3.2147829,4.591185 C 4.5820213,28.882003 4.5185467,29.240591 4.2587,29.422537 3.9988533,29.604484 3.6401816,29.541486 3.4580386,29.281359",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0342195
    },
    id: "path776-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.822582,24.229246 H 28.43498 c -0.13513,0 -0.244751,-0.306076 -0.244751,-0.682878 0,-0.376802 0.109622,-0.682878 0.244751,-0.682878 h 2.387602 c 0.135276,0 0.244897,0.306076 0.244897,0.682878 0,0.376802 -0.109622,0.682878 -0.244897,0.682878",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0243419
    },
    id: "path776-6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcehockey);
export default __webpack_public_path__ + "static/media/icehockey.edd031a5b0f88b096c2d3a183f9e1f83.svg";
export { ForwardRef as ReactComponent };